import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import SvgLanguage from '../../svg/Language';
import SvgWheelchair from '../../svg/Wheelchair';
import { Switch } from '@mui/material';

import './Footer.css';

import { setLanguage } from '../../store/actions/langActions';
import { setAccessibility } from '../../store/actions/accessActions';

interface IFooterProps {}

const Footer: React.FC<IFooterProps> = () => {
    const dispatch = useDispatch();
    const [toggleLang, setToggleLang] = useState(false);
    const [langDisplay, setLangDisplay] = useState('FR');

    const [toggleAccess, setToggleAccess] = useState(false);
    const [date, setDate] = useState(new Date());
    const [timeDisplay, setTimeDisplay] = useState('fr-FR');

    useEffect(() => {
        var timer = setInterval(() => setDate(new Date()), 1000);
        return function cleanup() {
            clearInterval(timer);
        };
    });

    const chooseLanguageHandler = (target: HTMLInputElement) => {
        setToggleLang(target.checked);
        if (toggleLang) {
            dispatch(setLanguage('FR'));
            setLangDisplay('FR');
            setTimeDisplay('fr-FR');
        } else {
            dispatch(setLanguage('EN'));
            setLangDisplay('EN');
            setTimeDisplay('en-US');
        }
    };
    const chooseAccessibilityHandler = (target: HTMLInputElement) => {
        setToggleAccess(target.checked);
        if (toggleAccess) {
            dispatch(setAccessibility('OFF'));
        } else {
            dispatch(setAccessibility('ON'));
        }
    };

    return (
        <div className="FooterOuter Drop-Shadow ">
            <div className="FooterInner">
                <div className="FooterLeft">
                    <div className="FooterIcon">
                        <SvgLanguage width={'1.67vw'} height={'2.96vh'} color="#424559" />
                    </div>
                    <Switch checked={toggleLang} onChange={(e) => chooseLanguageHandler(e.target)} color="success" />
                    <div>{langDisplay}</div>
                </div>
                <div className="FooterCenter">
                    <div className="FooterDate">{date.toLocaleDateString(timeDisplay, { dateStyle: 'full' })}</div>
                    <div className="FooterTime">{date.toLocaleTimeString(timeDisplay, { hour: '2-digit', minute: '2-digit' })}</div>
                </div>
                <div className="FooterRight">
                    <div className="FooterIcon">
                        <SvgWheelchair width={'1.67vw'} height={'2.96vh'} color="#424559" />
                    </div>
                    <Switch checked={toggleAccess} onChange={(e) => chooseAccessibilityHandler(e.target)} />
                </div>
            </div>
        </div>
    );
};

export default Footer;
